import {SDynamicComponent} from "@/components/dto/SDynamicComponent";
import {ObjUtils} from "@/components/utils/ObjUtils";
import {STemplateElement} from "@/components/dto/STemplateElement";
import {STemplateElementAttr} from "@/components/dto/STemplateElementAttr";

export class SourceGenerator {


    static generateTemplate(schema: SDynamicComponent[]): STemplateElement[]{
        return this.generateTag(schema)
    }

    static generateTag(schema: SDynamicComponent[]): STemplateElement[]{
        let tags: STemplateElement[] = [];
        schema.forEach(item => {
            let tag: STemplateElement = {elementName: '', elementAttr:[{name:'', value:''}], body: []};
            tag.elementName = item.component.name;
            tag.elementAttr = this.generateAttribute(item.data);
            tag.body = this.generateBody(item.data);
            tags.push(tag);
        });
        return tags;
    }

    static generateBody(data: Object): STemplateElement[]{
        if('body' in data){
            return this.generateTag(ObjUtils.prop(data, 'body'));
        }
        return [];
    }

    static generateAttribute(data: Object): STemplateElementAttr[]{
        let attr:STemplateElementAttr[]= [];
        Object.keys(data).forEach(key => {
            if(key !== 'body') {
                let item:STemplateElementAttr = {name:'', value:''};
                item.name = key;
                item.value = ObjUtils.prop(data, key);
                attr.push(item);
            }
        });
        return attr;
    }
}
